import React, {useContext, useEffect, useState} from 'react';

import {Navigate} from 'react-big-calendar';

import {getISOWeek} from 'date-fns';
import {postPrograms} from "../api/api";
import ProgramPlaner from "../weekPlaner/ProgramPlaner";
import {APIContext} from "../Globals.tsx";

export default function WeexWeekProgram({date, localizer, ...props}){
  const [programms, setProgramms] = useState([[],[],[],[],[],[],[]])
  const [selectedCourseType, setSelectedCourseType] = useState(0)
  const {fetchPrograms} = useContext(APIContext)

  function save(data){
    console.log(data)
    const jsonString = JSON.stringify(data.map(e => e.filter(e => e.fixed === undefined)));

    postPrograms(localizer.startOf(date, 'week').toLocaleDateString('de-DE'), localizer.endOf(date, 'week').toLocaleDateString('de-DE'), selectedCourseType.short, jsonString).then((a)=>setProgramms(a.days))
  }

  async function fetch(){
    return await fetchPrograms(localizer.startOf(date, 'week').toLocaleDateString('de-DE'), localizer.endOf(date, 'week').toLocaleDateString('de-DE'), selectedCourseType.short, !props?.preview)
  }
  useEffect( () => {
    if(selectedCourseType)
      fetch().then((week)=>setProgramms(week.days))
  },[date, selectedCourseType])

  return (<div>
      <ProgramPlaner weekProgramm={programms} onSave={save} setSelectedCourseType={setSelectedCourseType} selectedCourseType={selectedCourseType} preview={props?.preview ?? false} startOfWeek={localizer.startOf(date, 'week')}/>
    </div>
  );
}

WeexWeekProgram.navigate = (date, action, {localizer}) => {
  switch(action){
    case Navigate.PREVIOUS:
      return localizer.add(date, -7, 'day');

    case Navigate.NEXT:
      return localizer.add(date, 7, 'day');

    default:
      return date;
  }
};

WeexWeekProgram.title = (date, {localizer}) => {
  return `${localizer.startOf(date, 'week').toLocaleDateString('de-DE')} - ${localizer.endOf(date, 'week').toLocaleDateString('de-DE')} KW ${getISOWeek(date)}`;
};